import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

const ROUTE = process.env.VUE_APP_SHOP_V2_BASE_URI
const ENTITY = 'companies'

export default abstract class CompaniesApi {
  public static baseRoute = `${ROUTE}/${ENTITY}`

  public static async list(params: string): Promise<AxiosResponse> {
    return await axios.get(`${this.baseRoute}?${params}`)
  }

  public static async create(data: object): Promise<AxiosResponse> {
    return await axios.post(`${this.baseRoute}`, data)
  }

  public static async get(id: string): Promise<AxiosResponse> {
    return await axios.get(`${this.baseRoute}/${id}`)
  }

  public static async update(id: string, data: object): Promise<AxiosResponse> {
    return await axios.patch(`${this.baseRoute}/${id}`, data)
  }

  public static async delete(id: string): Promise<AxiosResponse> {
    return await axios.delete(`${this.baseRoute}/${id}`)
  }

  public static async addArena(
    id: string,
    data: object,
  ): Promise<AxiosResponse> {
    return await axios.post(`${this.baseRoute}/${id}/add-arena`, data)
  }

  public static async removeArena(
    id: string,
    data: object,
  ): Promise<AxiosResponse> {
    return await axios.post(`${this.baseRoute}/${id}/remove-arena`, data)
  }
}
